module.exports = __webpack_public_path__ + "static/media/thoughts2.f46d12a2.jpg";